export default __webpack_public_path__ + "static/media/3350.5be90c5b.png";